import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { DemoBanner } from "@components/demo";
import { PATHS } from "@constants/Paths";
import { mustAcceptTerms } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import { getIsDemoUser } from "@stores/utils";
import { PlansBillingProvider } from "@stores/PlansBillingContext";
export const AuthLayout = () => {
    const { onLogin, user } = useAuthContext();
    const isDemoUser = getIsDemoUser(user);
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const tokenFromSearch = searchParams.get("token");
    const isAuthenticating = useRef(false);
    // The report-ready email links to /o/:orgId/overview/:id?token=…; older emails to /overview/:id.
    const isOverviewRoute = /^(\/o\/[^/]+)?\/overview\//.test(location.pathname);
    useEffect(() => {
        if (!tokenFromSearch)
            return;
        isAuthenticating.current = true;
        onLogin({ token: tokenFromSearch }, true, { skipRedirect: isOverviewRoute });
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.delete("token");
            return next;
        }, { replace: true });
    }, [onLogin, tokenFromSearch, isOverviewRoute, setSearchParams]);
    if ((tokenFromSearch || isAuthenticating.current) && !user) {
        return null;
    }
    if (!user) {
        return React.createElement(Navigate, { to: PATHS.LOGIN, replace: true, state: { redirectTo: location } });
    }
    if (user && !isDemoUser && mustAcceptTerms(user)) {
        return React.createElement(Navigate, { to: PATHS.TERMS_CONDITIONS_AGREEMENT, replace: true, state: { redirectTo: location } });
    }
    return (React.createElement(PlansBillingProvider, null,
        React.createElement(DemoBanner, null),
        React.createElement(Outlet, null)));
};
export default AuthLayout;
